import React, { useContext } from 'react';
import SectionItem from '../SectionItem/SectionItem';
import CustomSectionItem from '../SectionItem/CustomSectionItem';
import { translate } from '../../../utils/helpers';
import { camelToStartCase } from '../../../utils/format';
import { CioAutocompleteContext } from '../CioAutocompleteProvider';
import NoResults from '../AutocompleteResults/NoResults';
// eslint-disable-next-line func-names
const DefaultRenderSectionItemsList = function ({ section }) {
    const { getSectionProps, query, getFormProps, advancedParameters } = useContext(CioAutocompleteContext);
    const { displayShowAllResultsButton, translations } = advancedParameters || {};
    const { onSubmit } = getFormProps();
    const { type, displayName, displayNoResultsMessage } = section;
    let sectionTitle = displayName;
    if (!sectionTitle) {
        switch (type) {
            case 'recommendations':
                sectionTitle = section.podId;
                break;
            case 'autocomplete':
                sectionTitle = section.indexSectionName;
                break;
            case 'custom':
                sectionTitle = section.displayName;
                break;
            default:
                sectionTitle = section.indexSectionName;
                break;
        }
    }
    // Display no results message
    if (!section?.data?.length && displayNoResultsMessage)
        return (React.createElement("li", { ...getSectionProps(section) },
            React.createElement("h5", { className: 'cio-section-name cio-sectionName', "aria-hidden": true }, camelToStartCase(sectionTitle)),
            React.createElement(NoResults, null)));
    if (!section?.data?.length)
        return null;
    // @deprecated `cio-sectionName` will be removed in the next major release
    return (React.createElement("li", { ...getSectionProps(section) },
        React.createElement("h5", { className: 'cio-section-name cio-sectionName', "aria-hidden": true }, camelToStartCase(sectionTitle)),
        React.createElement("ul", { className: 'cio-section-items', role: 'none' }, section?.data?.map((item) => {
            if (typeof section?.renderItem === 'function') {
                return (React.createElement(CustomSectionItem, { renderItem: section.renderItem, item: item, query: query, key: item?.data?.variation_id || item?.id }));
            }
            return (React.createElement(SectionItem, { item: item, key: item?.data?.variation_id || item?.id, displaySearchTermHighlights: section.displaySearchTermHighlights }));
        })),
        displayShowAllResultsButton &&
            (typeof type === 'undefined' || type === 'autocomplete') &&
            section.indexSectionName === 'Products' && (React.createElement("div", { className: 'cio-section-footer' },
            React.createElement("button", { "data-cnstrc-search-submit-btn": true, className: 'cio-show-all-results-button', type: 'button', onClick: onSubmit }, translate('show all results', translations))))));
};
export default function SectionItemsList(props) {
    const { section, children = DefaultRenderSectionItemsList } = props;
    return children({ section });
}
